import { useEffect } from "react";

import correct from "../../../../assets/images/correct.svg";
import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";

function MessageFormCompleted() {
	const { setPreviousStep, currentStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	useEffect(() => {
		setPreviousStep(currentStep - 1);
	}, []);

	return (
		<div className="step-page" id="end">
			<section>
				<img className="success-icon" src={correct} alt="OK" />
				<h3>Su solicitud fue realizada con éxito.</h3>
				<h4>A la brevedad nos contactaremos con usted.</h4>
				<p>
					Si tuvo algun inconveniente durante el proceso de solicitud, puede contactarnos a través
					de a <a href="mailto:marcapais@lsqa.com">marcapais@lsqa.com</a>
				</p>
			</section>
		</div>
	);
}

export { MessageFormCompleted };
